<template>
  <div class="flex items-center">
    <PSpinner v-show="loading" :enabled="loading" :size="loadSize" />
    <OhVueIcon v-show="!loading" :name="checkIcon" class="text-success-425" :scale="scale" />
  </div>
</template>

<script setup lang="ts">
import { PSpinner, useIcons } from "@pasta/box-v2";
import { OhVueIcon } from "oh-vue-icons";
import { FcCheckmark } from "oh-vue-icons/icons";

interface Props {
  loading: boolean;
  scale: string;
  loadSize: "sm" | "md" | "lg";
}
withDefaults(defineProps<Props>(), {
  loading: false,
  scale: "1",
  loadSize: "md",
});

const [checkIcon] = useIcons(FcCheckmark);
</script>
